import { render, staticRenderFns } from "./datenschutz.vue?vue&type=template&id=538645ba&"
import script from "./datenschutz.vue?vue&type=script&lang=js&"
export * from "./datenschutz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports